import { useCallback } from "react"
import type { PreOrderSuggestion } from "@stockline/shared/types/ai/pre-order-suggestion"
import { PRE_ORDER_SUGGESTION_TABLE } from "../../../lib/offline/resources/ai/pre-order-suggestion/db"
import { useAISync } from "../providers/AISyncProvider"

/** Resolution stamp the recap writes when a user accepts/declines. */
export type ResolvePreOrderSuggestionInput = Partial<
  Pick<PreOrderSuggestion, "acceptedAt" | "declinedAt" | "resolvedBy">
>

export function usePreOrderSuggestionMutations() {
  const { storage, changeQueue, engine } = useAISync()

  const resolve = useCallback(
    async (
      id: string,
      input: ResolvePreOrderSuggestionInput
    ): Promise<void> => {
      const existing = await storage.get<PreOrderSuggestion>(
        PRE_ORDER_SUGGESTION_TABLE,
        id
      )
      if (!existing) return
      const updated: PreOrderSuggestion = {
        ...existing,
        ...input,
        updatedAt: new Date().toISOString(),
      }
      await storage.put(PRE_ORDER_SUGGESTION_TABLE, updated)
      await changeQueue.enqueue("pre-order-suggestions", {
        op: "update",
        id,
        data: input,
      })
      void engine.pushChanges("pre-order-suggestions")
    },
    [storage, changeQueue, engine]
  )

  return { resolve }
}
